import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import { imgBaseURL } from "apis/Admin";

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiTextField-root": {
            margin: theme.spacing(2, 0),
        },
    },
    modal: {
        maxHeight: "80vh",
        overflow: "auto",
    },
    postCard: {
        display: "flex",
        flexDirection: "column",
        margin: "20px",
        justifyContent: "center",
        alignItems: "center"
    },
    postHeading: {
        textAlign: "center",
        fontSize: "30px",
        color: "#4eafa4",
    },
    PostImages: {
        marginTop: "10px",
        width: "100%"
    },
    description: {
        textAlign: "center",
        margin: "10px 0",
    },
    card: {
        maxHeight: "80vh",
        overflow: "auto",
        textAlign: "center",
        background: "black"
    },
    songHeading: {
        fontSize: "18px",
        color: "white",
        margin: " 10px 30px"
    }
}));

const ViewImage = ({ data }) => {
    const classes = useStyles();

    return (
        <Card
            variant="outlined"
            color="primary"
            className={`${classes.root} ${classes.modal}`}
        >
            <div className={classes.postCard}>
                <div className={classes.postHeading}>Identity Proof Image</div>
                <div>
                    {data?.data?.identityProof && data?.data?.identityProof !== "" && <img
                        src={`${imgBaseURL}/${data?.data?.identityProof}`}
                        className={classes.PostImages}
                        alt={"Identity Proof Image" + data?.data?._id}
                    />
                    }
                </div>
            </div>
        </Card>
    );
}

export default ViewImage
